import "./Dash.scss";
import React from "react";
import { observer } from "mobx-react";
import { authStore, resultStore } from "../stores";
import { Result } from "../result";
import { Redirect, NavLink, Switch, Route } from "react-router-dom";
import InviteLink from "./InviteLink";
import Responses from "./Responses";

const ResultsPage = observer(() => {
  return (
    <Result
      phaseId={resultStore.phase.stage}
      questions={resultStore.responses}
      side={resultStore.lifecycleSide}
      full={true}
    />
  );
});

const ResponsesPage = observer(() => {
  return (
    <div className="card" style={{ padding: 30 }}>
      <h4>Questions</h4>
      <hr />
      <Responses responses={resultStore.churchResponse} />
    </div>
  );
});

const InvitePage = observer(() => {
  return (
    <div className="card">
      <div style={{ padding: 10 }}>
        <h4>Invite your team</h4>
        <hr />
        <InviteLink />
      </div>
    </div>
  );
});

const ResetPage = observer(() => {
  return (
    <div className="card">
      <div style={{ padding: 10 }}>
        <h4>Take Again?</h4>
        <p style={{ fontSize: 18 }}>
          <b>
            This will delete your current assessment results and reset your
            account.
          </b>
        </p>
        <br />
        <button
          onClick={(x) => {
            console.log("click");
            resultStore.takeAgain();
          }}
          className="Button Button-primary"
        >
          I understand. Delete results and start over.
        </button>
        <br />
        <br />
      </div>
    </div>
  );
});

const Dash = ({ match }) => {
  if (!authStore.authenticating && !authStore.auth) {
    return <Redirect to="/" />;
  }
  if (resultStore.noChurchData) {
    return <Redirect to="/assess/leader" />;
  }
  if (!resultStore.churchData) {
    return null;
  }
  return (
    <div className="Dash">
      <div className="container">
        <div className="menu">
          <nav className="nav">
            <NavLink to={`${match.url}/results`}>My Church</NavLink>
            <NavLink to={`${match.url}/responses`}>Responses</NavLink>
            <NavLink to={`${match.url}/invite`}>Invite</NavLink>
            <NavLink to={`${match.url}/reset`}>Take Again</NavLink>
          </nav>
          <a href="#" onClick={authStore.signOut.bind(authStore)}>
            Logout
          </a>
        </div>
        <Switch>
          <Route path={`${match.path}/results`} component={ResultsPage} />
          <Route path={`${match.path}/responses`} component={ResponsesPage} />
          <Route path={`${match.path}/invite`} component={InvitePage} />
          <Route path={`${match.path}/reset`} component={ResetPage} />
          <Route
            path={match.path}
            exactly
            render={() => <Redirect to={`${match.url}/results`} />}
          />
        </Switch>
      </div>
    </div>
  );
};

Dash.displayName = "Dash";

export default observer(Dash);



// WEBPACK FOOTER //
// ./src/dash/Dash.js